__turbopack_context__.v({
  "container": "SplashText-module__nrMGwW__container",
  "containerActive": "SplashText-module__nrMGwW__containerActive",
  "fadeInItems": "SplashText-module__nrMGwW__fadeInItems",
  "row": "SplashText-module__nrMGwW__row",
  "scrollLeft": "SplashText-module__nrMGwW__scrollLeft",
  "scrollRight": "SplashText-module__nrMGwW__scrollRight",
  "spacing--lg": "SplashText-module__nrMGwW__spacing--lg",
  "spacing--md": "SplashText-module__nrMGwW__spacing--md",
  "spacing--sm": "SplashText-module__nrMGwW__spacing--sm",
  "spacing--xl": "SplashText-module__nrMGwW__spacing--xl",
  "spacing--xs": "SplashText-module__nrMGwW__spacing--xs",
  "spacing--xxl": "SplashText-module__nrMGwW__spacing--xxl",
  "spacing--xxs": "SplashText-module__nrMGwW__spacing--xxs",
  "spacing--xxxl": "SplashText-module__nrMGwW__spacing--xxxl",
  "spacing--xxxs": "SplashText-module__nrMGwW__spacing--xxxs",
  "text": "SplashText-module__nrMGwW__text",
  "textActive": "SplashText-module__nrMGwW__textActive",
});
